import Swal from "sweetalert2";
import axios from "axios";
import websiteConfig from '../config.js';
import {trans} from '../Components/utils.js';

export function processSettings(settings) {
    console.log(settings);
    for (let item of settings) {

        if (item.key === "title") {
            localStorage.setItem('SystemTitle', item.value);
        } else if (item.key === "logo") {
            localStorage.setItem('ClientLogo', item.value);
        } else if (item.key === "facilityLabelEn") {
            localStorage.setItem('facilityLabelEn', item?.value);
        } else if (item.key === "facilityLabelAr") {
            localStorage.setItem('facilityLabelAr', item?.value);
        }else if (item.key === "staffLabelEn") {
            localStorage.setItem('staffLabelEn', item?.value);
        } else if (item.key === "staffLabelAr") {
            localStorage.setItem('staffLabelAr', item?.value);
        } else if (item.key === "slaFlow") {
            localStorage.setItem('slaFlow', item?.value);
        } else if (item.key === "MedicalOnly") {
            localStorage.setItem('MedicalOnly', item?.value == 1 ? 1 : 0);
        }
    }
}
export const convertToWoButtonAction = (ticket, history) => {
    const routeChange = path => {
        history.push(path);
    }

    let url = "/WorkOrder/Add/" + ticket.id;
    let isNewFlowEnabled = localStorage.getItem('slaFlow') == 1;
    
    if (isNewFlowEnabled && (ticket.priority_id == null)) {
        axios.get(websiteConfig.SystemUrl+'select/Priority?is_select=1&page=0').then((response) => {
            const options = response.data.data.filter(option => option.status !== "suspended");
            let inputOptions = {};
            options.forEach((option) => {
                inputOptions[option.id] = option.title;
            })
            
            Swal.fire({
                title: trans('Set Priority'),
                input: 'select',
                inputOptions: inputOptions,
                inputPlaceholder: trans('Select priority'),
                showCancelButton: true,
                confirmButtonText: trans('Submit'),
                cancelButtonText: trans('Cancel'),
                preConfirm: (selectedValue) => {
                    if (!selectedValue) {
                        Swal.showValidationMessage(trans('You need to select a priority!'));
                        return false; // Return false to prevent closing
                    } else {
                        return selectedValue; // Return the selected value for submission
                    }
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    // FIXME: make it post to a custom route to update one field only
                    const data = {
                        priority_id: result.value,
                        room_item_id: ticket?.room_space_item_without_scopes?.id??ticket?.room_space_item?.id ,
                        description : ticket.description,
                    };
                    
                    
                    axios.put(websiteConfig.SystemUrl+'Ticket/'+ticket.id+'?get_edit_form=true&edit_id='+ticket.id, data)
                        .then(() => {
                            routeChange(url); // Redirect to the specified URL
                        })
                        .catch((error) => {
                            console.error('There was an error!', error);
                            // Handle the error if needed
                        });
                }
            });
            
        }).catch((error) => {});


    } else {
        
        routeChange(url);
    }

}
